/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import { PopModal } from './components/PopModal';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Logout from './components/Logout';
import Dashboard from './views/Console/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import SetPassword from './components/SetPassword';
import E404 from './components/E404';
import { ImageViewCom } from './components/ImageView';
import Globals from './shared/Globals';
import { loadLang, pullCurrentLang } from './shared/GLang';
import Menu from './components/Menu';
import { Layout } from './components/Layout';
import Home from './views/Home';
import './css/style.css';
import './css/animations.css';
import ConsoleLayout from './components/ConsoleLayout';
import APISpec from './views/Console/APISpec';
import APIKeyManager from './views/Console/APIKeyManager';
import WebhookManager from './views/Console/WebhookManager';
import UserManager from './views/Console/Admin/User/UserManager';
import UserEdit from './views/Console/Admin/User/UserEdit';
import Admin from './views/Console/Admin/Admin';
import LabOrderList from './views/Console/Lab/LabOrderList';
import Internal from './views/Console/Internal/Internal';
import HealthMonitor from './views/Console/HealthMonitor';
import APIClientManager from './views/Console/Admin/APIClient/APIClientManager';
import APIClientEdit from './views/Console/Admin/APIClient/APIClientEdit';
import HealthCheckManager from './views/Console/Admin/HealthCheck/HealthCheckManager';
import HealthCheckEdit from './views/Console/Admin/HealthCheck/HealthCheckEdit';
import AnalyzerList from './views/Console/Internal/Analyzer/AnalyzerList';
import AnalyzerEdit from './views/Console/Internal/Analyzer/AnalyzerEdit';
import WebhookLog from './views/Console/WebhookLog';


export const AppGlobal = {
    setLang() { }
};

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'es',
            serverUrl: Globals.serverUrl
        };
        this.setLang = this.setLang.bind(this);
        AppGlobal.setLang = this.setLang;
    }

    componentDidMount() {
        this.init();
    }

    init = (serverUrl) => {
        if (serverUrl) {
            Globals.serverUrl = serverUrl;
            this.setState({ serverUrl: serverUrl });
        }
        loadLang(() => {
            pullCurrentLang(lang => {
                this.setState({ lang: lang });
            });
        });
    }

    setLang(lang) {
        Globals.setLang(lang);
        this.setState({ lang: lang });
    }

    render() {
        return (<>
            <PopModal />
            <ImageViewCom />
            <ToastContainer position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light" />
            <BrowserRouter lang={this.state.lang}>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:code" element={<SetPassword />} />
                        <Route path="/reset-password/:code/invite" element={<SetPassword invite />} />
                        <Route element={<ConsoleLayout />} path="/console">
                            <Route index path="dashboard" element={<Dashboard />} />
                            <Route path="api-credential" element={<APIKeyManager />} />
                            <Route path="webhook" element={<WebhookManager />} />
                            <Route path="webhook/log" element={<WebhookLog />} />
                            <Route path="health" element={<HealthMonitor />} />
                            <Route path="spec/:ident" element={<APISpec />} />
                            <Route path="menu" element={<Menu />} />

                            <Route path="lab">
                                <Route index path="order" element={<LabOrderList />} />
                            </Route>

                            <Route path="internal" element={<Internal />}>
                                <Route index path="analyzer" element={<AnalyzerList />} />
                                <Route index path="analyzer/edit" element={<AnalyzerEdit />} />
                                <Route index path="analyzer/edit/:id" element={<AnalyzerEdit />} />
                            </Route>

                            <Route path="admin">
                                <Route index element={<Admin />} />
                                
                                <Route path="user" element={<UserManager />} />
                                <Route path="user/new" element={<UserEdit />} />
                                <Route path="user/:id" element={<UserEdit />} />

                                <Route path="api-client" element={<APIClientManager />} />
                                <Route path="api-client/new" element={<APIClientEdit />} />
                                <Route path="api-client/:id" element={<APIClientEdit />} />

                                <Route path="healthcheck" element={<HealthCheckManager />} />
                                <Route path="healthcheck/new" element={<HealthCheckEdit />} />
                                <Route path="healthcheck/:id" element={<HealthCheckEdit />} />
                            </Route>
                            <Route path="*" element={<E404 />} />
                        </Route>
                        <Route path="*" element={<E404 />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
        );
    }
}